webpackJsonp([12],{

/***/ 598:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(749);

var _angular = __webpack_require__(0);

var _angular2 = _interopRequireDefault(_angular);

var _cities = __webpack_require__(751);

var _cities2 = _interopRequireDefault(_cities);

var _city_list = __webpack_require__(753);

var _city_list2 = _interopRequireDefault(_city_list);

var _seo_cities = __webpack_require__(755);

var _seo_cities2 = _interopRequireDefault(_seo_cities);

__webpack_require__(756);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dependencies = [];

exports.default = _angular2.default.module('cities', dependencies).component('saCities', _cities2.default).component('saCityList', _city_list2.default).factory('seoCS', _seo_cities2.default).name;

/***/ }),

/***/ 749:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(750);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(12)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--6-1!../../../../node_modules/sass-loader/lib/loader.js??ref--6-2!./cities.css", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--6-1!../../../../node_modules/sass-loader/lib/loader.js??ref--6-2!./cities.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 750:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)();
exports.push([module.i, ".Cities-Breadcrumbs-Wrapper{background:#f8f9f4;height:55px;display:flex;align-items:center;box-shadow:0 -1px 4px 1px rgba(0,0,0,.15)}.Cities-Breadcrumbs{max-width:1000px;width:100%;margin:auto;padding:0 10px}@media (min-width:1200px){.Cities-Breadcrumbs{max-width:1200px}}.Cities-Breadcrumbs-Link-current{color:#999}.Cities-Breadcrumbs-Arrow{color:#999;font-weight:600;padding:0 5px}.Cities-List{max-width:1000px;margin:0 auto 100px;overflow:hidden}@media (min-width:1200px){.Cities-List{max-width:1200px}}.Cities-List h1{margin:36px 0 35px;font-size:30px;font-weight:900;text-align:center;color:#323337}.Cities-List ul::after{clear:both;content:\"\";display:table}.Cities-List-Item{padding:0 30px}.Cities-List-Item a{display:block;width:100%;height:100%;margin:0 auto;border-bottom:1px solid #ced1cd;line-height:46px;color:#03a9f4}.is-hoverEnabled .Cities-List-Item a:hover{text-decoration:underline}.Cities-List-Item h2{margin:0 -20px 5px;color:#666}.Cities-List-LocalCount{float:right;color:#777;font-weight:600}.is-hoverEnabled .Cities-List-LocalCount:hover{text-decoration:none}.Cities-Loaded{display:block}.Cities-Loading{display:none}.Loading{display:block}", ""]);

/***/ }),

/***/ 751:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _cities = __webpack_require__(752);

var _cities2 = _interopRequireDefault(_cities);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  template: _cities2.default,
  controller: ['$stateParams', 'seoCS', 'deslug', 'slug', function controller($stateParams, seoCS, deslug, slug) {
    'ngInject';

    var _this = this;

    this.slug = slug;

    this.$onInit = function () {
      _this.location = deslug.it($stateParams.name);
      seoCS.getLocalCities(slug.it(_this.location)).then(function (result) {
        _this.data = result.data;
        _this.count = result.data.reduce(function (a, v) {
          return a + v.count * 1;
        }, 0);
      }).finally(function () {
        _this.fetched = true;
      });
    };
  }]
};

/***/ }),

/***/ 752:
/***/ (function(module, exports) {

module.exports = "<div>\n  <div class=\"Cities Cities-Loaded\">\n\n    <div class=\"Cities-Breadcrumbs-Wrapper\">\n      <div class=\"Cities-Breadcrumbs\">\n        <a class=\"Link Link--blue\" ui-sref=\"guides.landing\">Home</a>\n        <span class=\"Cities-Breadcrumbs-Arrow\">⟶</span>\n        <a class=\"Link Link--blue\" ui-sref=\"countries\">Countries</a>\n        <span class=\"Cities-Breadcrumbs-Arrow\">⟶</span>\n        <a class=\"Link Cities-Breadcrumbs-Link-current\" ui-sref=\"cities({name: $ctrl.location})\">{{$ctrl.location | deslug}}</a>\n      </div>\n    </div>\n\n    <sa-content-loader ng-if=\"!$ctrl.fetched\"></sa-content-loader>\n    <div class=\"Cities-List\" ng-if=\"$ctrl.fetched\">\n      <div ng-if=\"$ctrl.location != 'Austria'\">\n        <h1 ng-bind-html=\"::'CITIES.EXPLORE' | translate:{ COUNT: $ctrl.count, LOCATION: $ctrl.location }\"></h1>\n      </div>\n\n      <div ng-if=\"$ctrl.location == 'Austria'\">\n        <h1 ng-bind-html=\"::'CITIES.EXPLORE_OLD' | translate:{ COUNT: $ctrl.count, LOCATION: $ctrl.location }\"></h1>\n      </div>\n\n      <div class=\"row\">\n        <sa-city-list city-list=\"$ctrl.data\" country=\"$ctrl.slug.it($ctrl.location)\"></sa-city-list>\n      </div>\n    </div>\n  </div>\n  <sa-content-loader class=\"Cities-Loading\"></sa-content-loader>\n</div>\n";

/***/ }),

/***/ 753:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _city_list = __webpack_require__(754);

var _city_list2 = _interopRequireDefault(_city_list);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  template: _city_list2.default,
  bindings: {
    cityList: '<?',
    country: '<?'
  }
};

/***/ }),

/***/ 754:
/***/ (function(module, exports) {

module.exports = "<div class=\"col-xs-12 col-md-4\" ng-repeat=\"city in $ctrl.cityList\">\n  <div class=\"Cities-List-Item\">\n    <ul>\n      <li><a ui-sref=\"guides.city({country: $ctrl.country, city: city.slug })\">{{city.name}} <span class=\"Cities-List-LocalCount\">{{city.count | round}}</span></a></li>\n    </ul>\n  </div>\n</div>\n";

/***/ }),

/***/ 755:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = f;
f.$inject = ['$http', 'utils'];
function f($http, utils) {
  'ngInject';

  return {
    getLocalCities: function getLocalCities(countryName) {
      return $http.get(utils.getApiUrl('intro/local_city/' + countryName));
    }
  };
}

/***/ }),

/***/ 756:
/***/ (function(module, exports) {

angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "CITIES": {
    "EXPLORE_OLD": "Explore {LOCATION} with one of {COUNT, plural, one{# local} other{# locals}} who can show you around",
    "EXPLORE": "Tours with locals in {LOCATION}, with one of {COUNT, plural, other{# local}} guides"
  }
}
);  }]);

/***/ })

});


// WEBPACK FOOTER //
// js/12.1fba536c3b139986d326.js